<template>
    <bottom-dialog
        v-model="showBookingDialog"
        scrollable
        max-width="850px"
        :dialog="!$vuetify.breakpoint.mobile"
        v-if="showBookingDialog"
        :persistent="true">
        <v-card
            class="zoezi-bottom-sheet"
            tile
            elevation="0">
            <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="font-weight-bold fill-width">
                    <span v-text="competitionAndGameClassName" />
                    <v-btn
                        icon
                        @click="showBookingDialog = false"
                        class="float-right"
                        v-if="!checkoutLoading"
                        ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn
                    >
                </div>
            </v-card-title>

            <v-card-text class="z-no-x-scroll">
                <checkout
                    ref="checkout"
                    class="overflow-y-auto"
                    :items="checkoutItems"
                    :expand-first-item="false"
                    :show-summary="true"
                    :show-back-link="false"
                    :show-payment-button="false"
                    :user-read-only="true"
                    @loading="checkoutLoading = $event"
                    @close="showBookingDialog = false"
                    @done="showBookingDialog = false; gotDone = true"
                    @cost="cost = $event"
                    @readyToPay="readyToPay = $event"
                    content-target="checkoutcontent"
                    :dialog="true"
                    :new-style-done-dialog="true"
                    :count-read-only="true"
                    @reservation-timeout="reservationTimeout"
                >
                    <template #content>
                        <stepper-content
                            v-model="currentStep"
                            :steps="steps">
                            <template #account>
                                <div>
                                    <v-icon>mdi-account-check-outline</v-icon>
                                    <span class="ml-2 font-weight-bold">{{ $translate('Who are you who book?') }}</span>
                                </div>
                                <div v-if="$store.state.user">
                                    <div class="pa-2 d-flex">
                                        <div class="d-flex align-center">
                                            <v-icon color="primary">mdi-account-star-outline</v-icon>
                                        </div>
                                        <div class="ml-2 flex-grow-1">
                                            <span class="font-weight-bold">{{ $store.state.user.name }}</span
                                            ><span
                                                @click.stop="$store.dispatch('logout')"
                                                class="z-clickable primary--text text-decoration-underline ml-4"
                                                >{{$translate('Not you?')}}</span
                                            >
                                        </div>
                                    </div>

                                    <div class="error--text" v-if="individualIsAlreadyRegistered">
                                        {{$translate('Already registered')}}
                                    </div>
                                </div>
                                <identification v-else>
                                    <template #header>
                                        <div v-if="canBookForOthers">
                                            Logga in med <b>dina personliga</b> uppgifter här.<br>
                                            Bokar du åt någon annan lägger du till dem i nästa steg.
                                        </div>
                                        <div v-else>
                                            {{$translate(('Choose which method you want to use to identify yourself.'))}}
                                        </div>
                                    </template>
                                </identification>
                            </template>
                            <template #membership>
                                <membership-checkout
                                    :items="checkoutItemsForMembershipCheckout"
                                    @buy="onBuyMembership" />
                            </template>
                            <template #team>
                                <div class="font-weight-bold"><v-icon class="mr-1">mdi-account-group</v-icon>{{$translate('Choose team')}}</div>

                                <div class="d-flex flex-wrap mt-2 align-center">
                                    <v-btn
                                        v-for="group in groups"
                                        :key="group.id"
                                        class="ma-2"
                                        small
                                        :outlined="selectedGroupId == group.id"
                                        :text="selectedGroupId != group.id"
                                        :color="selectedGroupId == group.id ? 'primary' : null"
                                        :disabled="!bookableGroups.find(x => x.id == group.id)"
                                        @click="selectedGroupId = group.id"
                                        style="height: 48px"
                                    >
                                        <v-auto-img v-if="group.imagekey" :src="group.imagekey ? group.imagekey : undefined" height="32" width="32" class="mr-1" />
                                        {{group.name }}
                                        <span v-if="gc.teams.find(team => team.group && team.group.id == group.id)" class="error--text ml-2">
                                            {{$translate('Already registered2')}}
                                        </span>
                                        <span v-else-if="groupHasTooFewMembers(group)" class="error--text ml-2">
                                            {{$translate('Too few players in team')}}
                                        </span>
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        :outlined="!selectedGroupId"
                                        :text="!!selectedGroupId"
                                        @click="selectedGroupId = null"
                                        style="height: 48px"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                        {{$translate('Add new team')}}
                                    </v-btn>
                                </div>
                                
                                <v-row>
                                    <v-col cols="8">
                                        <v-form @submit.prevent="newTeamDone && $refs.stepper.nextClicked()" v-model="newTeamDone" v-if="!selectedGroupId">
                                            <form-field v-for="field in newTeamFields" :field="field" :key="field.name" v-model="newTeam[field.name]" star />
                                        </v-form>
                                    </v-col>
                                    <v-col cols=4>
                                        <teamsport-team-logo :upper-color="newTeam.shirtColor" :lower-color="newTeam.shortsColor" :name="newTeam.shortName" @image-created="newTeam.image = $event" />
                                    </v-col>
                                </v-row>
                            </template>
                            <template #questions>
                                <template v-if="canBookForOthers">
                                    <div><v-icon>mdi-account-question-outline</v-icon><span class="ml-2 font-weight-bold">{{$translate('Who to book?')}}</span></div>

                                    <v-btn color="primary" :outlined="!newUserPrimaryColor" block class="zoezi-button-thin" @click="showAdduserDialog">
                                        <v-icon left :color="newUserPrimaryColor ? 'primarytext' : 'primary'">mdi-account-plus</v-icon>
                                        {{$translate('Add participant')}}
                                    </v-btn>

                                    <v-form v-model="questionsDone">
                                        <div class="z-rounded-box my-2" v-for="user in bookableUsers" :key="user.id">
                                            <div class="pa-2 d-flex">
                                                <div class="d-flex align-center">
                                                    <v-simple-checkbox v-model="user.selected" color="primary" :ripple="false" :disabled="user.reserving || user.booked || user.isBlocked() || (isFull && !user.reservation)" @input="userSelectedClicked(user, $event)" />
                                                </div>
                                                <div class="ml-2 flex-grow-1">
                                                    <span class="font-weight-bold">{{user.name}} {{user.me ? '(Du)' : ''}}</span>
                                                    <span v-if="user.booked" class="red--text ml-4">Redan inbokad</span>
                                                    <span v-else-if="user.isBlocked()" class="red--text ml-4">{{ $translate('Blocked') }}</span>
                                                    <span v-else-if="isFull && !user.reservation" class="red--text ml-4">{{ $translate('fully booked').capitalize() }}</span>
                                                </div>
                                                <div class="ml-2 align-end" v-if="!user.me">
                                                    <span class="z-clickable primary--text text-decoration-underline ml-4" @click.stop="showChangeUserDialog(user)">Ändra</span>
                                                </div>
                                                <div class="float-right" @click="user.expanded = !user.expanded" v-if="user.selected && gc.questions && gc.questions.length">
                                                    <v-icon>{{user.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                                                </div>
                                            </div>

                                            <v-expand-transition v-if="gc.questions && gc.questions.length">
                                                <div v-if="user.selected" class="px-2" v-show="user.expanded">
                                                    <form-field v-for="q in questions" :key="q.name" :field="q" star v-model="user.answers[q.name]" />

                                                    <div class="d-flex mb-1">
                                                        <v-btn color="primary" outlined class="flex-grow-1 zoezi-button-thin mr-1" @click="showAdduserDialog">
                                                            <v-icon left color="primary">mdi-account-plus</v-icon>
                                                            {{$translate('Additional participant')}}
                                                        </v-btn>
                                                        <v-btn color="primary" class="zoezi-button-thin ml-1" @click="user.expanded = false">Klar</v-btn>
                                                    </div>
                                                </div>
                                            </v-expand-transition>
                                        </div>
                                    </v-form>
                                </template>
                                <template v-else>
                                    <v-form @submit.prevent="questionsDone && $refs.stepper.nextClicked()" v-model="questionsDone">
                                        <form-field v-for="q in questions" :key="q.name" :field="q" star v-model="teamLeaderUser.answers[q.name]" />
                                    </v-form>
                                </template>
                            </template>
                            <template #checkout>
                                <portal-target name="checkoutcontent" />
                            </template>
                        </stepper-content>
                    </template>
                </checkout>
            </v-card-text>
            <v-card-actions>
                <stepper
                    v-model="currentStep"
                    :steps="steps"
                    @cancel="showBookingDialog = false"
                    ref="stepper"
                    :disabled="checkoutLoading" />
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
    const colors = [
        {value: '#F8F8F8', text: 'White'},
        {value: '#000000', text: 'Black'},
        {value: '#ff0000', text: 'Red'},
        {value: '#00ff00', text: 'Green'},
        {value: '#0000ff', text: 'Blue'},
        {value: '#ffff00', text: 'Yellow'},
        {value: '#ff00ff', text: 'Purple'},
        {value: '#00ffff', text: 'Cyan'},
        {value: '#ff8000', text: 'Orange'}
    ];

    import BottomDialog from '../components/BottomDialog.vue'
    import Checkout from '../views/Checkout.vue'
    import Stepper from '../views/Stepper.vue'
    import StepperContent from '../views/StepperContent.vue'
    import Identification from '../views/Identification.vue'
    import MembershipCheckout from './MembershipCheckout.vue'
    import FormField from '../components/FormField.vue'
    import TeamsportTeamLogo from '../components/TeamsportTeamLogo.vue'
    import { formatPrice, getName } from '../util.js'
    export default {
        name: 'zoezi-teamsport-booking',

        zoezi: {
            title: 'Competition registration',
            icon: 'mdi-soccer',
            addon: 'TeamSports'
        },

        props: {
            gameClassId: {
                title: 'Game class ID',
                type: Number
            }
        },

        components: {
            BottomDialog,
            Checkout,
            Stepper,
            StepperContent,
            Identification,
            MembershipCheckout,
            FormField,
            TeamsportTeamLogo
        },

        data: () => ({
            gc: null,
            responsibleGroups: [],
            loading: true,
            showBookingDialog: false,
            currentStep: 0,
            checkoutLoading: false,
            cost: null,
            readyToPay: false,
            membership: null,
            selectedGroupId: null,
            questions: null,
            questionsDone: false,
            newTeamDone: false,
            newTeam: {
                name: '',
                shortName: '',
                shirtColor: null,
                shortsColor: null,
                image: null
            },
            newTeamFields: [
                {name: 'name', type: 'text', title: 'Team name', required: true, rules: []},
                {name: 'shortName', type: 'text', title: 'Abbreviation (max 4 characters)', max: 4, required: true},
                {name: 'shirtColor', type: 'color', title: 'Team color upper half', required: true, colors},
                {name: 'shortsColor', type: 'color', title: 'Team color lower half', required: true, colors}
            ],
            users: [],
            unsubscribe: null,
            gotDone: false
        }),

        computed: {
            competitionAndGameClassName() {
                if (!this.gc) {
                    return ''
                }
                return this.gc.competition.name + ' ' + this.gc.name
            },
            checkoutItems() {
                if (!this.gc) {
                    return []
                }
                let items = [];
                this.users.filter(x => x.selected).forEach(user => {
                    items.push({
                        product_id: this.gc.product_id,
                        price: this.gc.price,
                        name: this.competitionAndGameClassName,
                        user_id: user.id,
                        reservation: user.reservation,
                        teamsportregistration: {
                            gameclass_id: this.gameClassId,
                            user_id: user && this.gc.individual ? user.id : null,
                            group_id: !this.gc.individual ? this.selectedGroupId : null,
                            create_group: !this.gc.individual && this.selectedGroupId == null ? {
                                name: this.newTeam.name,
                                image: this.newTeam.image
                            } : undefined,
                            registration_answers: user.answers
                        }
                    })

                    if (user.membership) {
                        items.push({count: 1, users: [user.id], product_id: user.membership.id, product: user.membership});
                    }
                })

                return items;
            },
            teamLeaderUser() {
                return this.users.find(x => x.selected);
            },
            checkoutItemsForMembershipCheckout() {
                let memberships = this.users.filter(user => user.selected && user.membership).map(u => ({
                    count: 1,
                    users: [u.id],
                    product: u.membership
                }))
                const requireMembership = this.gc.competition.require_membership
                const startDate = Date.newFull(this.gc.competition.startDate)
                const endDate = Date.newFull(this.gc.competition.endDate)
                return [{
                    product: {requireMembership, startDate, endDate},
                    users: this.users.filter(user => user.selected).map(user => user.id)
                }].concat(memberships);
            },
            individualIsAlreadyRegistered() {
                return this.$store.state.user && this.gc?.individual && this.gc.teams.find(team => team.user_id && team.user_id == this.$store.state.user.id) && !this.canBookForOthers;
            },
            steps() {
                if (!this.gc) {
                    return []
                }

                const showMemberships = this.$booking.isMembershipRequired(this.checkoutItemsForMembershipCheckout)
                const membershipsComplete = !this.$booking.isMembershipStillRequired(this.checkoutItemsForMembershipCheckout)
                const showTeamStep = !this.gc.individual;
                const teamComplete = this.selectedGroupId != null || this.newTeamDone;
                const showQuestions = (this.gc.questions && this.gc.questions.length) || this.canBookForOthers;
                const t = this.$translate;

                return [
                    {
                        title: t('Account'),
                        id: 'account',
                        complete: this.$store.state.isLoggedIn && !this.individualIsAlreadyRegistered
                    },
                    showMemberships && {
                        title: t('Membership'),
                        id: 'membership',
                        complete: membershipsComplete,
                        nextTitle: t(membershipsComplete ? 'Continue' : 'Choose membership')
                    },
                    showTeamStep && {
                        title: t('The team'),
                        id: 'team',
                        complete: teamComplete
                    },
                    showQuestions && {
                        title: t('Questions'),
                        id: 'questions',
                        complete: this.questionsDone && (!this.gc.individual || this.selectedUsersCount)
                    },
                    {
                        title: t('Complete'),
                        id: 'checkout',
                        nextTitle: this.cost > 0 ? `${t('Pay')} ${formatPrice(this.cost)}` : t('Confirm purchase'),
                        nextColor: '#7bbd1b',
                        nextDark: true,
                        nextClicked: this.pay,
                        nextLoading: this.checkoutLoading,
                        complete: this.readyToPay
                    }
                ].filter((x) => x)
            },
            groups() {
                if (!this.$store.state.user || !this.gc) {
                    return [];
                }
                return this.responsibleGroups.filter(g => g.type != 'family' && (!g.teamsport_id || g.teamsport_id == this.gc.competition.teamsport_id));
            },
            bookableGroups() {
                if (!this.gc) {
                    return [];
                }
                return this.groups.filter(group => {
                    return !this.gc.teams.find(team => team.group && team.group.id == group.id) && !this.groupHasTooFewMembers(group);
                })
            },
            bookableUsers() {
                if (!this.gc) {
                    return [];
                }
                if (this.gc.canBookFor && !this.gc.canBookFor.includes('self')) {
                    return this.users.filter(x => !x.me);
                }

                return this.users;
            },
            selectedUsersCount() {
                return this.bookableUsers.filter(x => x.selected).length;
            },
            newUserPrimaryColor() {
                return this.selectedUsersCount == 0;
            },
            canBookForOthers() {
                return this.gc?.canBookFor?.includes('others');
            },
            isFull() {
                return this.gc && this.gc.spaceLeft == 0;
            }
        },

        methods: {
            pay() {
                this.$refs.checkout.completePurchase()
            },
            onBuyMembership(product, user) {
                let u = this.users.find(u => u.id == user.id);
                u.membership = product;
                if (!this.$booking.isMembershipStillRequired(this.checkoutItemsForMembershipCheckout)) {
                    this.currentStep += 1;
                }
            },
            setInitialTeamSelection() {
                if (!this.gc || this.gc.individual) {
                    return
                }

                if (this.bookableGroups.length) {
                    this.selectedGroupId = this.bookableGroups[0].id;
                }
            },
            setInitialStepWhenLoggedIn() {
                const step = this.steps[this.currentStep];
                if (this.$store.state.isLoggedIn && step && step.id == 'account' && step.complete) {
                    this.currentStep += 1
                }
            },
            setUsers() {
                if (!this.gc || !this.$store.state.user) {
                    return;
                }
                const bookSelf = this.gc.canBookFor == 'self' || this.gc.canBookFor == 'self+others';
                this.users = this.$store.state.user.canBookFor.map((user,userindex) => ({
                    id: user.id,
                    name: user.name,
                    selected: this.$store.state.user.id == user.id && bookSelf,
                    me: this.$store.state.user.id == user.id,
                    reservation: null,
                    reserving: false,
                    expanded: userindex == 0,
                    membership: null,
                    answers: null,
                    booked: null,
                    isBlocked: () => this.$store.state.user.canBookFor.find(x => x.id == user.id)?.isBlocked('block_course')
                }));
                this.updateUsers();
            },
            updateUsers() {
                if (!this.gc) {
                    return;
                }
                this.users.forEach(user => {
                    if (!user.answers) {
                        let answers = {};
                        if (this.gc.questions) {
                            this.gc.questions.forEach(q => {
                                answers[q.name] = null;
                            })
                        }
                        this.$set(user, 'answers', answers)
                    }

                    user.booked = this.gc.individual && !!this.gc.teams.find(team => team.user_id && team.user_id == user.id);

                    if (user.selected && user.booked) {
                        user.selected = false;
                    }

                    if (user.selected && !user.reservation && !user.reserving) {
                        this.reserve(user);
                    }

                    if (!user.selected && user.reservation) {
                        this.unreserve(user);
                    }
                })
            },
            showAdduserDialog() {
                this.$store.commit('showAddUserDialog', {
                    title: 'Lägg till ny deltagare',
                    booking_fields: true,
                    callback: (data) => {
                        let user = {
                            id: data.id,
                            name: getName(data),
                            selected: true,
                            me: false,
                            reservation: null,
                            reserving: false,
                            expanded: true,
                            membership: null,
                            answers: null,
                            booked: null,
                            isBlocked: () => this.$store.state.user.canBookFor.find(x => x.id == user.id)?.isBlocked('block_course')
                        };
                        this.users.push(user);
                        this.updateUsers();
                    }
                });
            },
            showChangeUserDialog(user) {
                this.$store.commit('showChangeUserDialog', {
                    user_id: user.id
                });
            },
            userSelectedClicked(user, selected) {
                user.expanded = selected;
                this.updateUsers();
            },
            reserve(user) {
                if (user.reserving || !this.gc) {
                    return;
                }
                user.reserving = true;
                let data = {gameclass_id: this.gameClassId};
                this.$api.post('/api/resource/reservation/add', data).then(response => {
                    user.reserving = false;
                    if (response.ok) {
                        response.json().then(x => {
                            user.reservation = x.key;
                        });
                    } else {
                        this.$store.commit('showErrorDialog', {title: 'Fel vid reservering', text: 'Något gick fel när bokningen skulle reserveras'});
                        user.selected = false;
                    }
                });
            },
            unreserve(user) {
                if (user.reserving || !user.reservation) {
                    return;
                }
                user.reserving = true;
                this.$api.post('/api/resource/reservation/cancel', {key: user.reservation}).then(() => {
                    user.reserving = false;
                    user.reservation = null;
                    user.selected = false;
                });
            },
            unreserveAll() {
                let rusers = this.users.filter(user => user.reservation);
                let keys = rusers.map(user => user.reservation);
                if (keys.length) {
                    // FIXME: Look into this: Would this work? In that case, do the same for CourseBooking.vue
                    if (!this.gotDone && !this.checkoutLoading) {
                        this.$api.post('/api/resource/reservation/cancel', {key: keys});
                    }
                    rusers.forEach(user => {
                        user.reserving = false;
                        user.reservation = null;
                        user.selected = false;
                    })
                }
            },
            teamNameRule(x) {
                return this.gc.teams.find(team => team.group && team.group.name == x) ? this.$translate('There is already a team registered with that team name') : true;
            },
            groupHasTooFewMembers(group) {
                return this.gc && this.gc.min_number_of_players && this.gc.min_number_of_players > group.users.length;
            },
            getGroups() {
                this.$api.get('/api/memberapi/usergroup/get_responsible_for').then(result => {
                    this.responsibleGroups = result;
                });
            },
            reservationTimeout() {
                this.showBookingDialog = false;
            }
        },

        watch: {
            gameClassId: {
                immediate: true,
                handler() {
                    if (!this.gameClassId) return
                    this.loading = true
                    this.$api.get('/api/teamsport/gameclass/get_for_memberpage', {id: this.gameClassId}).then((gc) => {
                        this.gc = gc
                        this.loading = false
                        this.showBookingDialog = true
                        let questions = [];
                        if (gc.questions) {
                            gc.questions.forEach(q => {
                                q = Object.assign({}, q, {title: q.name});
                                questions.push(q);
                            })
                        }
                        this.questions = questions;

                        this.setInitialStepWhenLoggedIn();
                        this.setInitialTeamSelection();
                        this.setUsers();
                    })
                }
            },
            '$store.state.isLoggedIn': {
                immediate: true,
                handler(isLoggedIn) {
                    this.setInitialStepWhenLoggedIn();

                    if (isLoggedIn && this.$store.state.user && this.$store.state.user.canBookFor) {
                        this.setUsers()
                    }
                }
            },
            showBookingDialog() {
                if (!this.showBookingDialog) {
                    this.$emit('close');
                } else {
                    this.gotDone = false;
                }
            },
            groups: {
                immediate: true,
                handler() {
                    this.setInitialTeamSelection();
                }
            }
        },
        created() {
            this.newTeamFields.find(x => x.name == 'name').rules.push(this.teamNameRule);
        },
        mounted() {
            this.getGroups();
            window.addEventListener('beforeunload', this.unreserveAll);
            this.unsubscribe = this.$root.$api.subscribe({type: 'teamsportgameclass', callback: (_, event) => {
                let gc = this.gameClassId && event.data.find(gc => gc.id == this.gameClassId);
                if (gc) {
                    this.$api.get('/api/teamsport/gameclass/get_for_memberpage', {id: this.gameClassId}).then((gc) => {
                        this.gc = gc;
                        this.updateUsers();
                    });
                }
            }});
        },
        destroyed() {
            this.unsubscribe?.();
            this.unreserveAll();
            window.removeEventListener('beforeunload', this.unreserveAll);
        }
    }
</script>
